<template>
  <div>
    <Toolbar class="p-mb-4">
      <template #left>
        اضافه جديد
      </template>
      <template #right>
        <Button
          icon="pi pi-times"
          class="p-button-danger"
          @click="$router.push('/admin/championship')"
        />
      </template>
    </Toolbar>
    <div class="form-card">
      <div class="mb-3">
        <label for="leaguesId" class="form-label">
          المسابقه
        </label>
        <select
          class="form-select form-control"
          id="leaguesId"
          name="leaguesId"
          v-model="body.leaguesId"
        >
          <option v-for="item of leaguesList" :key="item.id" :value="item.id">{{
            item.name
          }}</option>
        </select>
      </div>

      <div class="mb-3">
        <label for="matcheNumber" class="form-label">
          رقم المباره
        </label>
        <input
          class="form-control"
          id="matcheNumber"
          v-model.number="body.matcheNumber"
        />
      </div>
      <div class="mb-3">
        <label for="academieOneId" class="form-label">
          الاكاديميه الاوله
        </label>
        <select
          class="form-select form-control"
          id="academieOneId"
          name="academieOneId"
          v-model="body.academieOneId"
        >
          <option
            v-for="item of academieList"
            :key="item.id"
            :value="item.id"
            >{{ item.userName }}</option
          >
        </select>
      </div>

      <div class="mb-3">
        <label for="academieTwoId" class="form-label">
          الاكاديميه الثانيه
        </label>
        <select
          class="form-select form-control"
          id="academieTwoId"
          name="academieTwoId"
          v-model="body.academieTwoId"
        >
          <option
            v-for="item of academieList"
            :key="item.id"
            :value="item.id"
            >{{ item.userName }}</option
          >
        </select>
      </div>

      <div class="mb-3">
        <label for="stadium" class="form-label">
          مكان المباره
        </label>
        <input class="form-control" id="stadium" v-model="body.stadium" />
      </div>

      <div class="mb-3">
        <label for="dayDate" class="form-label">
          تاريخ المباره
        </label>
        <input
          class="form-control"
          type="date"
          id="stadium"
          v-model="body.dayDate"
        />
      </div>

      <div class="mb-3 text-center">
        <Button
          label="اضافه جديد"
          icon="pi pi-plus"
          class="p-ml-2 p-button-success"
          @click="save()"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body: {
        stadium: null,
        leaguesId: null,
        matcheNumber: 0,
        academieOneId: null,
        academieTwoId: null,
        teamOneGoal: 0,
        teamTwoGoal: 0,
        dayDate: new Date(),
      },
      id: null,

      leaguesList: [],
      academieList: [],
    };
  },
  methods: {
    save() {
      if (
        this.body.stadium &&
        this.body.academieOneId &&
        this.body.academieTwoId &&
        this.body.matcheNumber &&
        this.body.leaguesId
      ) {
        this.$http.post(`championship`, this.body).then(
          () => {
            this.$toast.add({
              severity: 'success',
              summary: 'تم بنجاح',
              detail: 'تم الاضافه بنجاح',
              life: 3000,
            });
            this.$router.push('/admin/championship');
          },
          (err) => {
            this.$toast.add({
              severity: 'error',
              summary: 'هناك خطأ',
              detail: err.response.data.message,
              life: 3000,
            });
          },
        );
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'هناك خطأ',
          detail: 'يرجى ملاء الحقول',
          life: 3000,
        });
      }
    },
    getData() {
      this.$http
        .get(`years/findAllYearsAcademie?leaguesId=${this.body.leaguesId}`)
        .then((response) => {
          this.academieList = [];
          if (response.data && response.data.length > 0) {
            const list = response.data.map((i) => i.academieId);

            const key = 'id';

            this.academieList = [
              ...new Map(list.map((item) => [item[key], item])).values(),
            ];
          }
        });
    },
  },
  created() {
    this.$http.get(`league`).then((response) => {
      this.leaguesList = response.data;
      this.body.leaguesId = this.leaguesList[0]?.id;
    });

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.$http.get(`championship/${this.id}`).then(
        (res) => {
          this.body = res.data;
          this.body.leaguesId = res.data.leaguesId?.id;
          this.body.academieOneId = res.data.academieOneId?.id;
          this.body.academieTwoId = res.data.academieTwoId?.id;
        },
        (err) => {
          this.$toast.add({
            severity: 'error',
            summary: 'هناك خطأ',
            detail: err.response.data.message,
            life: 3000,
          });
        },
      );
    }
  },
  watch: {
    'body.leaguesId'() {
      this.getData();
    },
  },
};
</script>

<style>
.p-image {
  width: 0;
}
.p-image .custom-file-input {
  text-align: center;
  width: 89vw;
  position: absolute;
  top: -99px;
  height: 105px;
}
</style>
